import React from "react";
import Avatar from "@mui/material/Avatar";
import { avatarType } from "@/store/slices/notifications/types";
import * as styles from "./style.module.scss";

const NotificationAvatar = ({ type, avatar, icon, initials, name, classes}) => {
    return (
        (type === avatarType.avatar ? <Avatar
            alt={name}
            src={avatar}
            className={`${styles.avatarCircle} ${classes}`}
        /> : <Avatar
                alt={name}
                className={`${styles.avatarCircle} ${classes}`}
            >
                {type === avatarType.initials ? initials : icon}
            </Avatar>)
    );
};

export default NotificationAvatar;
